import React from "react"
import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Edificios from "../icons/edificios.svg";
import VentasIcon from "../icons/ventas.svg";
import Comunidad from "./pages/comercial/Comunidad";
import Inicio from "./pages/comercial/Inicio";
import AAFF from "./pages/comercial/AAFF";
import AAFFInformes from "./pages/comercial/AAFFInformes";
import Ventas from "./pages/general/Ventas";
import Comunidades from "./pages/comercial/Comunidades";
import DatosPerfil from "../components/perfil/datosPerfil";
import Proveedores from "./pages/comercial/Proveedores";
import Proveedor from "./pages/comercial/Proveedor";
import Instalaciones from "./pages/kae/instalaciones/Instalaciones";
import Instalacion from "./pages/kae/instalaciones/Instalacion";
import { Boxes, FileChartLine, Building2, MapPin } from "lucide-react";

export function RouteBundle() {
  return (
    <Routes>
      <Route path="/" element={<Inicio />} />
      <Route path="/aaff" element={<AAFF />} />
      <Route path="/aaff-informes" element={<AAFFInformes />} />
      <Route path="/servicios/" element={<Ventas />} />
      <Route path="comunidades/:nif" element={<Comunidad />} />
      <Route path="/aaff/:nif/comunidades" element={<Comunidades />} />
      <Route path="/aaff/:nif/comunidades/:nifFinca" element={<Comunidad />} />
      <Route path="/perfil" element={<DatosPerfil />} />
      <Route path="/aaff/:nif/proveedores" element={<Proveedores />} />
      <Route path="/proveedores/:nifProveedor" element={<Proveedor />} />
      <Route path="/instalaciones" element={<Instalaciones />} />
      <Route path="/instalaciones/:id" element={<Instalacion />} />
      <Route path="*" element={<Navigate to='/' replace/>}/>
    </Routes>
  )
}

const refrescoLocal = () => {
  localStorage.setItem("hasReloaded", "true");
}

export function MenuLinksClientes(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/aaff" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "",  color: props.showSidebar ? "#33383b" : "#fff"}}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <Building2 stroke-width="1.5" alt={t('clients.aaff')} />{t('clients.aaff')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          activeclassname="active"
          to="/servicios"
          style={{
            display: props.showSidebar ? "flex" : "block",
            alignItems: props.showSidebar ? "center" : "",
          }}
        >
          <div className="menuBtn" onClick={refrescoLocal}>
            <Boxes stroke-width="1.5" width="35px" alt={t('clients.services')} />{t('clients.services')}
          </div>
        </NavLink>
      </li>
    </>
  )
}
export function MenuLinksListado(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/aaff-informes" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <FileChartLine stroke-width="1.5" alt={t('reports.caeReports')} />{t('reports.caeReports')}
          </div>
        </NavLink>
      </li>
    </>
  )
}

export function MenuLinksKae(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/instalaciones" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <MapPin stroke-width="1.5" alt={t('kae.installations')} />{t('kae.installations')}
          </div>
        </NavLink>
      </li>
    </>
  )
}
